import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ActionListHistory, ActionListsHistoryStoreService } from '../../action-lists-history.store.service';
import { HistoryItemsProgressReporter } from '../../history-items-reporter.service';
import { ProgressReporter } from '../../progress-reporter.service';
import { ToggleEvent } from '../common';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ErrorsComponent {
  @Output() readonly toggleErrors = new EventEmitter<ToggleEvent>();
  @Input() isErrorShowing = false;
  private readonly historyItemId$$ = new ReplaySubject<string>(1);
  private readonly errorCount$: Observable<number>;
  private _itemData: ActionListHistory;

  constructor(
    // TODO: Use bulk actions reporter once it starts accurately reporting errors.
    @Inject(HistoryItemsProgressReporter) reporter: ProgressReporter,
    private actionListHistoryStoreService: ActionListsHistoryStoreService,
  ) {
    this.errorCount$ = this.historyItemId$$.pipe(
      switchMap((id) => reporter.getPolledStatus$(id)),
      map((v) => v.errors.length),
    );
  }

  @Input() set itemData(data: ActionListHistory) {
    this._itemData = data;
  }

  canDownload(): boolean {
    return this._itemData.actions.indexOf('download-skipped-file') >= 0;
  }

  canExpand(): boolean {
    return this._itemData.actions.indexOf('view-inline-errors') >= 0;
  }

  toggleClick(): void {
    const event: ToggleEvent = {
      itemId: this._itemData.itemId,
      showErrors: !this.isErrorShowing,
    };
    this.toggleErrors.next(event);
  }

  downloadClick(): void {
    this.actionListHistoryStoreService.downloadFile(this._itemData.skippedFile);
  }

  getText(): string {
    if (this.isErrorShowing) {
      return 'Hide Errors';
    }
    return 'View Errors';
  }
}
